var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultipleNeutral1 = function SvgMultipleNeutral1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "multiple-neutral-1_svg__Light",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".multiple-neutral-1_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.75,
    r: 4.25,
    className: "multiple-neutral-1_svg__cls-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 20.5a7 7 0 0 1 14 0ZM13.26 5a4.249 4.249 0 1 1 .74 6.189 4.4 4.4 0 0 1-.5-.429M14.5 13.79a7.005 7.005 0 0 1 9 6.71H17",
    className: "multiple-neutral-1_svg__cls-1"
  })));
};
export default SvgMultipleNeutral1;